<template>
  <div>
    <!-- <div v-if="isShow">  原先 -->
    <!-- <div id="phoneStrip-wrapper" ref="phoneStrip">
      <div
        class="c-flex"
        style="
          height: 100%;
          align-items: center;
          padding-left: 20px;
          justify-content: space-between;
        "
      >
        <div style="font-size: 20px; color: #fff">
          <template v-if="!isHandle">
            <i
              style="font-size: 24px; margin-right: 16px; color: #fff"
              class="fa fa-phone-volume"
            ></i>
            <span>{{ isIncomingCall }} 您有新的来电 ！！！</span>
          </template>
          <template v-else>
            <i style="font-size: 24px; margin-right: 16px; color: #fff" class="el-icon-success"></i>
            <span>{{ isIncomingCall }} 您正在处理来电...</span>
          </template>
        </div>
        <div>
          <el-menu
            class="menu-wrapper"
            :default-active="null"
            mode="horizontal"
            @select="handleSelect"
            text-color="#fff"
          > -->
    <!-- <el-menu-item index="2">
              <template slot="title" v-if="isBack">
                <span class="m-r-5">保持</span>
                <i class="c_white el-icon-phone-outline"></i>
              </template>
              <template slot="title" v-else>
                <span class="m-r-5">取回</span>
                <i class="c_white el-icon-thumb"></i>
              </template>
            </el-menu-item> -->

    <!-- <el-menu-item index="3" v-if="isBack">
              <template slot="title" v-if="!isTransfer">
                <span class="m-r-5">转移</span>
                <i class="c_white el-icon-position"></i>
              </template>
              <template slot="title" v-else>
                <span class="m-r-5">取消转移</span>
                <i class="c_white el-icon-close"></i>
              </template>
            </el-menu-item>
            <el-menu-item index="4" v-if="isBack && isTransfer && callMode == '6'">
              <template slot="title">
                <span class="m-r-5">确定转移</span>
                <i class="c_white el-icon-position"></i>
              </template>
            </el-menu-item>

            <el-menu-item index="1" v-show="!isHandle">
              <template slot="title">
                <span class="m-r-5">处理</span>
                <i class="c_white el-icon-phone"></i>
              </template>
            </el-menu-item>

            <el-menu-item index="5" v-show="isHandle">
              <template slot="title">
                <span class="m-r-5">{{ isZoom ? '展开' : '收起' }}</span>
                <i class="c_white el-icon-rank"></i>
              </template>
            </el-menu-item>
          </el-menu>
        </div>
      </div>
    </div> -->

    <!-- 呼叫弹窗 -->
    <template>
      <el-dialog
        height="100%"
        width="auto"
        class="phoneStrip-dialog"
        id="comprehensiveDialog"
        v-show="!isList"
        v-if="(record.openRecord = true)"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="record.openRecord"
        append-to-body
        @close="
          record.recordFormData = { exts: {} };
          record.SArecordFormData = {
            gpsPoint: {},
            exts: {}
          };
        "
      >
        <!-- 跟进记录表单 -->
        <c-form
          :formData="record.recordFormData"
          :fields="recordFields.filter(item => !item.frontEndConfig.phoneStripFormHide)"
          :options="options"
          ref="recordFormData"
          :upload="upload"
          labelWidth="100px"
          :area="area"
          :inline="true"
          labelPosition="top"
        >
          <template slot="dedicateMode">
            <el-cascader
              popper-class="cascaderLabelHide-wrapper"
              ref="cascaderRRdedicateMode"
              clearable
              v-model="record.recordFormData.dedicateMode"
              :options="options['LEADSTATUS']"
              :props="{
                checkStrictly: false,
                label: 'name',
                expandTrigger: 'hover'
              }"
              @change="dedicateModeChange"
            ></el-cascader>
          </template>
        </c-form>
        <el-tabs type="border-card" class="c-m-t-10" v-if="refresh">
          <el-tab-pane
            label="售后工单"
            v-if="$util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', '404')"
          >
            <c-form
              :formData="record.SAafterSaleFormData"
              :fields="workOrderFields.filter(item => !item.frontEndConfig.phoneStripFormHide)"
              :options="options"
              ref="SAafterSaleFormData"
              :upload="upload"
              labelWidth="100px"
              :area="area"
              :inline="true"
              labelPosition="top"
            >
              <div slot="phone">
                <el-input
                  v-model="record.SAafterSaleFormData.phone"
                  placeholder="关联查询线索和服务工单"
                  @blur="
                    getServiceAppointments(record.SAafterSaleFormData.phone);
                    getWorkOrders(record.SAafterSaleFormData.phone);
                    getLeads(record.SAafterSaleFormData.phone);

                    getRecord(record.SAafterSaleFormData.phone);
                  "
                ></el-input>
              </div>
            </c-form>
          </el-tab-pane>
          <el-tab-pane
            label="NPS回访"
            v-else-if="
              $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'NPS')
            "
          >
            <el-steps simple :active="stepsActive" finish-status="success">
              <el-step class="c-pointer" title="请选择合同">
                <div slot="title" @click="stepLast">请选择合同</div>
              </el-step>
              <el-step class="c-pointer" title="请填写NPS表单"></el-step>
            </el-steps>
            <div
              v-show="stepsActive == 0"
              style="height: 100%; display: flex; flex-direction: column"
            >
              <div style="flex: 1" v-if="contractShow">
                <!-- <div style="margin: 10px 0">
                  <el-input
                    style="width: 260px"
                    placeholder="请输入姓名或手机号、编号"
                    v-model="searchContractValue"
                    clearable
                    @clear="
                      contractFpi.page = 1;
                      getContract();
                    "
                    @keyup.enter.native="
                      contractFpi.page = 1;
                      getContract();
                    "
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click="
                        contractFpi.page = 1;
                        getContract();
                      "
                    ></el-button>
                  </el-input>
                </div> -->
                <el-table
                  ref="contractTable"
                  height="200px"
                  :data="contractFpi.data"
                  @selection-change="selectionChange"
                  @select="currentSelection"
                  @select-all="
                    $refs.contractTable.clearSelection();
                    selectedList = [];
                  "
                  v-if="contractFpi.data && contractFpi.data.length && extFieldsContract.length"
                >
                  <el-table-column type="selection" fixed width="55"></el-table-column>
                  <c-table :fields="extFieldsContract" :options="options"></c-table>
                </el-table>
                <el-pagination
                  class="pagination"
                  @size-change="pageSizeChange($event, 'contractFpi', getContract)"
                  @current-change="pageChange($event, 'contractFpi', getContract)"
                  :current-page="contractFpi.page"
                  :page-sizes="[10, 20, 50, 100]"
                  :page-size="contractFpi.rows"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="contractFpi.total"
                ></el-pagination>
              </div>
            </div>
            <div v-show="stepsActive == 1">
              <el-divider content-position="center">
                <i class="el-icon-info"></i>
                以下为NPS回访
              </el-divider>
              <c-form
                :formData="record.NPSformData"
                :fields="extFieldsNPS.filter(item => !item.frontEndConfig.phoneStripFormHide)"
                :options="options"
                ref="NPSform"
                :upload="upload"
                labelWidth="100px"
                :area="area"
              >
                <template slot="questionAndReply">
                  <el-card class="box-card" shadow="hover">
                    <div
                      slot="header"
                      class="c-flex c_item_center"
                      style="justify-content: space-between"
                    >
                      <span>罚款规则</span>
                      <el-button
                        :disabled="record.NPSformData._id ? true : false"
                        style="float: right; padding: 3px 0"
                        type="text"
                        @click="
                          record.NPSformData.questionAndReply.push({
                            id: '',
                            question: '',
                            reply: '',
                            whether: ''
                          })
                        "
                      >
                        新增
                      </el-button>
                    </div>
                    <div
                      v-for="(item, index) in record.NPSformData.questionAndReply"
                      :key="index"
                      :class="
                        `${
                          record.NPSformData.questionAndReply.length - 1 == index ? '' : 'c-m-b-20 '
                        }`
                      "
                    >
                      <div :class="`c-flex c-flex-item c-flex-between`">
                        <el-select
                          :disabled="record.NPSformData._id ? true : false"
                          placeholder="请选择问题"
                          v-model="item.question"
                          style="flex: 2"
                          @change="selectionQuestion($event, item)"
                        >
                          <el-option
                            v-for="subItem in options['questionBank']"
                            :key="subItem._id"
                            :label="subItem.name"
                            :value="subItem._id"
                            :disabled="
                              record.NPSformData.questionAndReply.some(
                                l => l.question == subItem.name
                              )
                            "
                          ></el-option>
                        </el-select>
                        <div style="flex: 1;align-items: center;" class="c-flex c-flex-around">
                          <el-radio-group
                            v-model="item.whether"
                            :disabled="record.NPSformData._id ? true : false"
                            class="c-flex c-m-l-10"
                          >
                            <el-radio
                              v-for="item in options['NPSreply']"
                              :key="item.value"
                              :label="item.value"
                            >
                              {{ item.label }}
                            </el-radio>
                          </el-radio-group>
                          <el-link
                            :underline="false"
                            @click="record.NPSformData.questionAndReply.splice(index, 1)"
                          >
                            <i
                              class="c-m-l-15 el-icon-delete"
                              v-if="record.NPSformData._id ? false : true"
                            ></i>
                          </el-link>
                        </div>
                      </div>
                      <div
                        class="c_red"
                        style="color: red"
                        v-if="item.whether > 0 && item.question"
                      >
                        此选项则会生成{{ String(item.reply) }}元罚款！
                      </div>
                    </div>
                  </el-card>
                </template>
              </c-form>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="售后工单回访"
            v-else-if="
              $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'review')
            "
          >
            <c-form
              :formData="record.reviewFormData"
              :fields="reviewFields.filter(item => !item.frontEndConfig.phoneStripFormHide)"
              :options="options"
              ref="review"
              :upload="upload"
              labelWidth="100px"
              :area="area"
              :inline="true"
              labelPosition="top"
            ></c-form>
          </el-tab-pane>
          <el-tab-pane label="服务工单" v-else>
            <c-form
              :formData="record.SArecordFormData"
              :fields="SAextFields.filter(item => !item.frontEndConfig.phoneStripFormHide)"
              :options="options"
              ref="SArecordFormData"
              :upload="upload"
              labelWidth="100px"
              :area="area"
              :inline="true"
              labelPosition="top"
              @changeForm="changeForm"
            ></c-form>
          </el-tab-pane>

          <el-tab-pane label="跟进记录" v-if="recordFields.length > 0">
            <el-table ref="recordTable" height="calc(100% - 80px)" :data="record.fpi.data">
              <c-table :fields="recordFields" :options="options"></c-table>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="历史线索" v-if="leadFields.length > 0">
            <div style="height: 100%; display: flex; flex-direction: column">
              <div style="height: 100%; display: flex; flex-direction: column">
                <div style="flex: 1">
                  <el-table ref="leadTable" height="calc(100% - 80px)" :data="leadFpi.data">
                    <c-table :fields="leadFields" :options="options" target="_blank"></c-table>
                  </el-table>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="客户信息"
            v-if="contact.fields && contact.fields.length > 0 && contact.formData._id"
          >
            <el-button
              type="text"
              icon="el-icon-link"
              class="c_size_14"
              @click="osg.open(null, {}, '_blank', '/Contact/' + contact.formData._id)"
            >
              点击此处跳转到客户详情页
            </el-button>
            <c-form
              :formData="contact.formData"
              :fields="contact.fields"
              :options="options"
              ref="contactFormData"
              :upload="upload"
              labelWidth="100px"
              :area="area"
              :inline="true"
              labelPosition="top"
              disabled
            ></c-form>
          </el-tab-pane>
        </el-tabs>
        <div  style="display: flex; justify-content: space-between;padding-top: 10px;">
          <div></div>
          <div>
            <el-button
              type="warning"
              @click="saveRecord('0')"
              v-if="
                !$util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'NPS')
              "
              :disabled="disableBtn"
            >
              仅创建跟进记录
            </el-button>
            <el-button
              type="primary"
              @click="saveRecord('2')"
              :disabled="disableBtn"
              v-if="$util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', '404')"
            >
              创建售后工单
            </el-button>
            <el-button
              type="primary"
              @click="saveRecord(3)"
              v-else-if="
                $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'NPS')
              "
              :disabled="disableBtn"
            >
              创建NPS
            </el-button>
            <el-button
              type="primary"
              @click="saveRecord('4')"
              :disabled="disableBtn"
              v-else-if="
                $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'review')
              "
            >
              创建售后工单回访
            </el-button>
            <el-button type="primary" @click="saveRecord('1')" :disabled="disableBtn" v-else>
              创建服务工单
            </el-button>
          </div>
        </div>        
        <el-divider content-position="left">
          <i class="el-icon-s-claim c_blue_default"></i>
          历史服务工单
        </el-divider>
        <el-table ref="ASTable" max-height="250px" :data="serviceAppointmentFpi.data">
          <c-table :fields="SAextFields" :options="options" :appKeyCode="token" target="_blank"></c-table>
        </el-table>
        <el-divider content-position="left">
          <i class="el-icon-service c_blue_default"></i>
          历史售后工单
        </el-divider>
        <el-table ref="ASTable" max-height="250px" :data="fpi.data">
          <c-table :fields="workOrderFields" :options="options" target="_blank">
            <template slot="type">
              <el-table-column label="售后工单类型" width="120" prop="type">
                <template slot-scope="scope">
                  {{ formatWorkOrderType(scope.row.exts.type) }}
                </template>
              </el-table-column>
            </template>
          </c-table>
        </el-table>
        <!-- <div slot="footer" style="display: flex; justify-content: space-between">
          <div></div>
          <div>
            <el-button
              type="warning"
              @click="saveRecord('0')"
              v-if="
                !$util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'NPS')
              "
              :disabled="disableBtn"
            >
              仅创建跟进记录
            </el-button>
            <el-button
              type="primary"
              @click="saveRecord('2')"
              :disabled="disableBtn"
              v-if="$util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', '404')"
            >
              创建售后工单
            </el-button>
            <el-button
              type="primary"
              @click="saveRecord(3)"
              v-else-if="
                $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'NPS')
              "
              :disabled="disableBtn"
            >
              创建NPS
            </el-button>
            <el-button
              type="primary"
              @click="saveRecord('4')"
              :disabled="disableBtn"
              v-else-if="
                $util.isShowField(record.recordFormData, 'dedicateMode', 'dedicateMode', 'review')
              "
            >
              创建售后工单回访
            </el-button>
            <el-button type="primary" @click="saveRecord('1')" :disabled="disableBtn" v-else>
              创建服务工单
            </el-button>
          </div>
        </div> -->
      </el-dialog>
    </template>

    <!-- 转移客服 -->
    <div v-show="!isPopUp && isTransfer">
      <el-dialog
        title="转移客服"
        v-if="!isPopUp && isTransfer"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="isTransfer"
        id="transferDialog"
      >
        <div style="width: 100%; min-height: 500px">
          <el-table
            ref="correspondentTable"
            :data="correspondentList"
            empty-text="暂无人员"
            height="500px"
          >
            <el-table-column prop="code" label="编号" min-width="100"></el-table-column>
            <el-table-column label="姓名" min-width="100">
              <template slot-scope="scope">
                {{ scope.row.name }}
              </template>
            </el-table-column>
            <el-table-column prop="phone" label="手机号" min-width="150px"></el-table-column>
            <el-table-column label="性别" width="100px">
              <template slot-scope="scope">
                <span>
                  {{ scope.row.sex == '1' ? '女' : scope.row.sex == '0' ? '男' : '' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="email" label="邮箱" min-width="150px"></el-table-column>
            <el-table-column label="操作" :width="80" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" @click.native.prevent="transferHandle(scope.row)">
                  转移
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncomingCall', 
    components: {
    cTable: () => import('../../components/table')
  }, 
  data() {
    window.$this = this;
    return {
      rules: this.$util.rules,
      isPopUp: false, //控制弹屏
      timingHour: 0, //时
      timingMinute: 0, //分
      timingSecond: 0, //秒
      timeInterval: null, //计时器
      isBack: true, //保持/取回
      isTransfer: false, //转移
      storagetransfer: {}, //要转移给的客服
      isConfirmTransfer: false, //转移
      correspondentList: [],
      callMode: '', //通话状态
      isShow: false,
      isZoom: false, //缩放
      isHandle: false, //处理
      // 跟进记录列表
      record: {
        fpi: {
          data: []
        },
        searchValue: '',
        searchDate: [],
        openRecord: false, // 跟进记录弹窗
        recordFormData: { afterSaleType: '', exts: {} }, //跟进记录表单

        reviewFormData: { exts: {} }, //审核回访表单
        SAafterSaleFormData: { name: '', phone: '', address: '', exts: {} }, //售后工单表单
        SArecordFormData: {
          name: '',
          phone: '',
          address: '',
          gpsPoint: {},
          exts: { newAddress: '' }
        }, //跟进记录表单-下（工单信息）
        callData: [], //跟进记录-通话记录
        openCallRecord: false, //跟进记录-通话记录弹窗
        NPSformData: { questionAndReply: [] } //NPS表单
      },
      // 联系人
      contactFields: [],
      contact: {
        formData: { exts: {} }
      },
      area: {
        options: this.osg.areaList,
        props: {
          expandTrigger: 'hover'
        }
      },
      extFields: [], //线索扩展字段

      recordFields: [], // 跟进记录字段
      workOrderFields: [], // 售后工单字段
      SAextFields: [], // 工单字段
      leadFields: [], // 线索字段
      reviewFields: [], // 审核回访字段

      extFieldsContract: [], //合同对象字段
      extFieldsNPS: [], //NPS对象字段
      extFieldsRecord: [], //跟进记录对象字段
      activeNames: ['1'],
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      disableBtn: false, //控制按钮禁用防止网络延迟大导致重复提交
      isList: false, //是否展示售后工单列表
      isRecordList: false, //是否展示跟进记录列表
      fpi: { data: [] }, //列表数据
      serviceAppointmentFpi: { data: [] },
      leadFpi: { data: [] },
      searchValue: '', //搜索列表内容
      contractFpi: {}, //合同列表数据
      selectedList: [], //选择合同，特殊处理为单选，只有一项
      stepsActive: 0, //NPS进度
      searchContractValue: '', //搜索合同列表参数
      randomQuestionNum: 3, //随机问题数量
      bizData: {}, //存储biz所需对象
      contractShow: false,
      refresh: true, // 子组件刷新
      options: {
        codecfg_lifecycleStage: { codeId: 'LIFECYCLESTAGE' },
        codecfg_callResult: { codeId: 'callResult' },
        cascadeCode_channel: { codeId: 'channel' },
        codecfg_leadDiscrepancy: { codeId: 'leadDiscrepancy' },
        codecfg_sex: { codeId: 'SEX' },
        //工单
        codecfg_priority: { codeId: 'PRIORITY' },
        codecfg_stage: { codeId: 'STAGE' },
        codecfg_status: { codeId: 'STATUS' },
        //通话记录
        cascadeCode_LEADSTATUS: { codeId: 'LEADSTATUS' },
        codecfg_callMode: { codeId: 'callMode' },
        codecfg_altertState: { codeId: 'altertState' },
        receiveType: [
          { label: '人员', value: 'personal' },
          { label: '角色', value: 'role' },
          { label: '全部', value: 'all' }
        ],
        users: [],
        roles: [],
        //售后类型细分
        cascadeCode_afterSaleType: { codeId: 'afterSaleType' },
        codecfg_IS: { codeId: 'IS' }, // 是否
        noticeData: [], //公告数据
        //NPS问题库
        codecfg_questionBank: {
          codeId: 'questionBank'
        },
        codecfg_NPSreply: { codeId: 'NPSreply' } //NPS答案
      },
      callId: '',
      isIncomingCall: '', // 呼入的客户电话
      callOutStripTheme: {}, //电话条采用单独的配置
      isRouterAlive: true, //控制视图是否显示
      routerData: '',
      token: '', //SessionStorage中存储的token
      call_id: '',  //通话记录id
      serviceAppointmentId: '',  //工单id
    };
  },
  mounted() {
    this.routerData = this.$route.query.app_key_code;
    this.callId = this.$route.query.LanderPhone;
    this.isIncomingCall = this.$route.query.isIncomingCall;
    this.call_id=this.$route.query.call_id;
    console.log(
      '综合大表单',
      this.routerData,
      '---this.routerData',
      this.callId,
      '---this.callId',
      this.isIncomingCall,
      '---this.isIncomingCall'
    );
    if (this.callId == '') return;
    console.log(this.callId, 'this.callId');
    this.getToken(() => {
      this.token = JSON.parse(sessionStorage.getItem('token'));
      console.log(this.token, '-------this.token第一次');

      this.getAccount();
      this.openFn();
      this.searchValue = this.isIncomingCall;
      // this.callAuthority();
      // 获取跟进记录字段
      this.osg.getFields(
        'followingUpNote',
        () => {
          // 获取来电的跟进记录列表
          this.getRecord();
          this.isShow = true;
        },
        this,
        'recordFields',
        null,
        null,
        { 'in:showList|string#and': '9' }
      );

      // 获取服务工单字段
      this.osg.getFields(
        'serviceAppointment',
        () => {
          // 获取历史服务工单
          this.getServiceAppointments();
        },
        this,
        'SAextFields',
        null,
        null,
        { 'in:showList|string#and': '9' }
      );

      // 获取线索字段
      this.osg.getFields(
        'lead',
        () => {
          // 获取历史线索
          this.getLeads();
        },
        this,
        'leadFields',
        null,
        null,
        { 'in:showList|string#and': '9' }
      );

      // 获取联系人字段
      this.osg.getFields(
        'contacts',
        () => {
          // 获取历史线索
          this.getContact();
        },
        this,
        'contact.fields',
        null,
        null,
        { 'in:showList|string#and': '9' }
      );

      // 获取审核回访表单字段
      this.osg.getFields('review', () => {}, this, 'reviewFields', null, null, {
        'in:showList|string#and': '9'
      });

      // 获取审核回访表单定义id
      this.osg.getFields('review', () => {}, this, 'reviewFields', null, null, {
        'in:showList|string#and': '9'
      });

      // 获取售后工单字段
      this.osg.getFields(
        'workOrder',
        () => {
          // 获取历史售后工单
          this.getWorkOrders();
        },
        this,
        'workOrderFields',
        null,
        null,
        { 'in:showList|string#and': '9' }
      );
      this.getConfig();
    });
    this.timeInterval = setInterval(() => {
      //时分秒计算
      this.timingSecond = +this.timingSecond + 1;
      this.timingMinute = this.timingMinute + parseInt(+this.timingSecond / 60);
      this.timingHour = this.timingHour + parseInt(+this.timingMinute / 60);
      if (+this.timingSecond == 60) this.timingSecond = 0;
      if (+this.timingMinute == 60) this.timingMinute = 0;
    }, 1000);
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.timeInterval);
    });

    // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    this.$once('hook:beforeDestroy', () => {
      clearInterval(this.timeInterval); //清除时分秒定时器
      clearInterval(this.queryCallStateInterval); //清除查询通话状态定时器
    });
  },
  // updated() {
  //   // 电话条上色
  //   if (this.profileTheme.themeColor) {
  //     if (this.$refs.phoneStrip)
  //       this.$refs.phoneStrip.style.background = this.profileTheme.themeColor;
  //     if (this.$refs.phoneStrippopUp)
  //       this.$refs.phoneStrippopUp.style.background = this.profileTheme.themeColor;
  //   }
  // },
  methods: {
    changeMsg(gPhone) {
      console.log(gPhone, '--------gPhone');
    },
    //刷新页面
    viewReload() {debugger
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
        this.$forceUpdate();
      });
    },
    // 查询当前通话状态
    getByCallState() {
      this.osg.ajax(
        'basic/sobot/queryByCallState.do',
        {
          callDirection: '0',
          callId: this.callId
        },
        res => {
          console.log('queryByCallState-this.callMode：' + res.data);
          this.callMode = res.data;
          if (res.data == '99') {
            this.isHangUp = true; //挂了就隐藏电话条
            this.isTransfer = false; //隐藏转移按钮
            clearInterval(this.timeInterval); //清除时分秒定时器
            clearInterval(this.queryCallStateInterval); //清除查询通话状态定时器
          }
        },
        { noload: true }
      );
    },
    handleSelect(el) {
      if (el == '1') this.openFn(); //处理-打开综合弹窗
      if (el == '2') this.keep(); //保持/取消保持
      if (el == '3') this.transfer(); //转移
      if (el == '4') this.confirmTransfer(); //确定转移
      if (el == '5') this.zoomFn(); //收缩/展开
    },
    //保持
    keep() {
      let url = this.isBack ? 'basic/sobot/handleAgentHold.do' : 'basic/sobot/handleAgentUnhold.do';
      this.osg.ajax(
        url,
        {
          callDirection: '0',
          callId: this.callId,
          caller: this.isIncomingCall
        },
        () => {
          this.isBack = !this.isBack;
          this.$emit('phoneStripFn', { isTransfer: false }); //取消转移
        }
      );
    },
    //申请转移
    transfer() {
      if (this.isTransfer) {
        //当取消转移，调取消转移接口
        this.osg.confirm('确定取消转移吗？', () => {
          this.osg.ajax(
            'basic/sobot/handleAgentConsultBack.do',
            {
              callDirection: '0',
              callId: this.callId,
              caller: this.isIncomingCall,
              userId: this.storagetransfer && this.storagetransfer._id
            },
            () => {
              this.osg.toast('取消转移成功！');
              this.isTransfer = !this.isTransfer;
              this.$emit('phoneStripFn', { isTransfer: this.isTransfer });
            }
          );
        });
      } else {
        this.$emit('phoneStripFn', { isTransfer: this.isTransfer });
        this.osg.confirm('确定转移吗？', () => {
          this.isTransfer = !this.isTransfer;
          this.getCorrespondent();
        });
      }
    },
    //查询当前空闲客服列表
    getCorrespondent() {
      let params = {
        callDirection: '0',
        callId: this.callId,
        caller: this.isIncomingCall,
        sortField: 'createTime',
        sortOrder: 'asc'
      };
      this.osg.ajax(
        'basic/sobot/usableAgentTransferList.do',
        params,
        res => {
          this.correspondentList = res.data;
          this.$nextTick(() => {
            this.$refs.correspondentTable.doLayout();
            this.$forceUpdate();
          });
        },
        { noload: true }
      );
    },
    //转客服按钮
    transferHandle(row) {
      this.storagetransfer = row;
      this.osg.confirm(`确定转移给"${row.name}" 吗？`, () => {
        this.osg.ajax(
          'basic/sobot/handleAgentTransfer.do',
          {
            callDirection: '0',
            userId: row._id,
            callId: this.callId,
            callWay: row.callWay
          },
          () => {
            console.log('transferHandle');
            console.log('isTransfer', this.isTransfer);
            console.log('isBack', this.isBack);
            this.osg.toast('转移成功！');
          },
          { noload: true }
        );
      });
    },
    //确定转移
    confirmTransfer() {
      this.osg.confirm(`确定转移给"${this.storagetransfer.name}" 吗？`, () => {
        this.osg.ajax(
          'basic/sobot/handleAgentTransferConfirm.do',
          {
            callDirection: '0',
            callId: this.callId,
            userId: this.storagetransfer._id
          },
          () => {
            this.osg.toast('转移成功！');
            this.record.openRecord = false;
            this.isTransfer = false;
          }
        );
      });
    },
    //打开处理弹窗
    openFn() {
      this.record.openRecord = true;
      this.isHandle = true;
      this.$set(this.record.recordFormData, 'callPhone', this.isIncomingCall);
      this.$set(this.record.SArecordFormData.exts, 'retentionDate', this.$util.readableTime());
      this.$set(this.record.SArecordFormData.exts, 'leadDiscrepancy', '10');
      this.$set(this.record.SAafterSaleFormData, 'retentionDate', this.$util.readableTime());
      this.$set(this.record.SAafterSaleFormData, 'leadDiscrepancy', '10');

      this.$set(this.record.SArecordFormData, 'phone', this.isIncomingCall);
      this.$set(this.record.SAafterSaleFormData, 'phone', this.isIncomingCall);

      // this.queryHasCall(null, () => {
      //   //来电赋值手机号
      //   this.$set(this.record.SArecordFormData, 'phone', this.isIncomingCall);
      //   this.$set(this.record.SAafterSaleFormData, 'phone', this.isIncomingCall);

      //   this.$router.push({
      //     path: '/IncomingCall',
      //     name: 'IncomingCall',
      //     params: { searchValue: this.isIncomingCall },
      //     query: {
      //       open: new Date().valueOf()
      //     }
      //   });

      //   //轮询调用，查询通话状态
      //   if (this.callId) {
      //     this.getByCallState();
      //     this.queryCallStateInterval = setInterval(() => {
      //       this.getByCallState();
      //     }, 6000);
      //   }
      // });
    },
    //缩放
    zoomFn() {
      this.isZoom = !this.isZoom;
      this.record.openRecord = !this.record.openRecord;
      this.isList = false; //列表隐藏
      this.isRecordList = false; //跟进记录列表
    },
    //获取跟进记录
    getRecord(phone) {
      var params = {
        _all: 1,
        // page:  1,
        // rows: 50,
        sortField: 'createTime',
        sortOrder: 'desc',
        'regex:callPhone|string#or': phone || this.searchValue
      };
      this.osg.ajax(
        'followingUpNote/query.do',
        params,
        res => {
          if (res.data) {
            this.record.fpi = res;
            this.$nextTick(() => {
              this.$forceUpdate();
            });
          }
        },
        {
          noload: true
        }
      );
    },
    //用于扩展字段，判断如果配置了因为某个字段值才显示
    isShowField(obj, key, showField, showValue) {
      if (
        obj[showField] &&
        (obj[showField] == showValue || Array.isArray(obj[showField])
          ? obj[showField].flat().indexOf(showValue) !== -1
          : obj[showField].indexOf(showValue) !== -1)
      )
        return true;

      obj.exts = obj.exts || {};
      if (
        obj.exts[showField] &&
        (obj.exts[showField] == showValue || Array.isArray(obj.exts[showField])
          ? obj.exts[showField].flat().indexOf(showValue) !== -1
          : obj.exts[showField].indexOf(showValue) !== -1)
      )
        return true;
    },
    //创建线索/建单
    saveRecord(state) {
      let status = null;
      if (state == '0') {
        //创建跟进记录，校验：跟进记录
        status =
          this.validate('recordFormData') &&
          this.validate(
            this.$util.isShowField(
              this.record.recordFormData,
              'dedicateMode',
              'dedicateMode',
              '404'
            )
              ? 'SAafterSaleFormData'
              : 'SArecordFormData',
            state
          );
      } else if (state == '1') {
        //创建服务工单，校验：跟进记录、服务工单表单
        status = this.validate('recordFormData') && this.validate('SArecordFormData', state);
        this.crmState();
      } else if (state == '2') {
        //创建售后工单，校验：跟进记录表单、售后工单表单
        status = this.validate('recordFormData') && this.validate('SAafterSaleFormData');
      } else if (state == '3') {
        // 创建NPS表单，校验：跟进记录表单、NPS表单
        status = this.validate('recordFormData') && this.validateCForm();
        if (
          this.record.NPSformData.questionAndReply.some(item => !item.question || !item.whether)
        ) {
          this.osg.toast('罚款规则或回答不能为空！', 'warning');
          return;
        }
      } else if (state == '4') {
        //创建回访，校验：跟进记录表单、回访表单
        status = this.validate('recordFormData') && this.validate('reviewFormData');
      }
      //生成跟进记录并建单
      if (status) {
        let form = this.$util.isShowField(
          this.record.recordFormData,
          'dedicateMode',
          'dedicateMode',
          '404'
        )
          ? 'SAafterSaleFormData'
          : 'SArecordFormData';
        //只校验手机号
        if (this.record[form].phone != '' && !/^1[3456789]\d{9}$/.test(this.record[form].phone)) {
          this.osg.toast('手机号格式有误！', 'warning');
          return;
        }

        if (this.osg.isRepeatClick('saveRecord', 10000)) {
          return;
        }
        this.disableBtn = true; // 提交了就禁用按钮
        //过了20秒接口没有响应恢复按钮
        setTimeout(() => {
          this.disableBtn = false; //恢复禁用的按钮
        }, 20000);
        let SArecordFormData = this.deepCopy(this.record.SArecordFormData);
        let SAafterSaleFormData = this.deepCopy(this.record.SAafterSaleFormData);
        //NPS创建跟进记录，不创建新线索
        if (state == '3') {
          this.saveRecordAjax(
            Object.assign(this.record.recordFormData, {
              bizId: this.bizData._id,
              bizType: 'Contract'
            }),
            () => {
              //保存NPS
              this.saveNPS(this.record.NPSformData, () => {
                this.record.recordFormData = { exts: {} };
                this.record.openRecord = false;
                this.disableBtn = false; //恢复禁用的按钮
                // this.queryHasCall({ del: '1' });
                this.doInit();
                this.viewReload();
                this.osg.toast('保存成功！');
              });
            }
          );
        } else {
          //创建新线索
          this.doLeadSave(this.converTempLead(SAafterSaleFormData, SArecordFormData), leadData => {
            // leadData._id;
            const UUID = this.randomUUid();
            //将线索与客户互相关联的特色接口，如果手机号在系统中没有，则新增联系人
            this.upsertLead(
              leadData,
              contactsData => {
                //TODO: 工单扩展字段存储与跟进记录相同的id
                this.record.recordFormData._id = UUID;
                this.record.recordFormData.name = SArecordFormData.name;
                this.record.recordFormData.phone = SArecordFormData.phone;
                this.record.recordFormData.province = SArecordFormData.province;
                this.record.recordFormData.city = SArecordFormData.city;
                this.record.recordFormData.district = SArecordFormData.district;
                this.record.recordFormData.address = SArecordFormData.address;
                this.record.recordFormData.channel = SArecordFormData.channel;
                this.record.recordFormData.leakagesite = JSON.stringify(
                  SArecordFormData.exts.leakagesite
                );
                this.record.recordFormData.bizId = leadData._id;
                this.saveRecordAjax(this.record.recordFormData, () => {
                  //给工单对象赋上线索id与客户id
                  SArecordFormData.leadIds = [leadData._id];
                  SArecordFormData.contactIds = [contactsData._id];
                  //TODO: 工单扩展字段存储与跟进记录相同的id
                  SArecordFormData.exts.followingUpNoteId = this.record.recordFormData._id;
                  if (state == '1') {
                    this.doSaveSA(SArecordFormData, () => {
                      this.updateCallLog()
                      this.doInit();
                    });
                    // this.queryHasCall({ del: '1' });
                  } else if (state == '2') {
                    //线索id赋值到售后工单上
                    this.record.SAafterSaleFormData.leadIdAfterSale = leadData._id;
                    //跟进记录id赋值到售后工单上
                    this.record.SAafterSaleFormData.followingUpNoteIdAfterSale = this.record.recordFormData._id;
                    //通话记录id赋值到售后工单上
                    this.record.SAafterSaleFormData.callIdAfterSale = this.callId;
                    //创建售后
                    this.saveWorkOrder(this.record.SAafterSaleFormData, () => {
                      // this.queryHasCall({ del: '1' });
                      this.doInit();
                    });
                  } else if (state == '4') {
                    this.saveReview(this.record.reviewFormData, () => {
                      this.doInit();
                    });
                    // this.queryHasCall({ del: '1' });
                  } else {
                    // this.queryHasCall({ del: '1' });
                    this.doInit();
                  }
                });
              },
              state
            );
          });
        }
      }
    },
    //根据跟进状态判断线索取值
    converTempLead(SAafterSaleFormData, SArecordFormData) {
      console.log(SAafterSaleFormData, SArecordFormData);
      // dedicateMode 404代表取售后表单，NPS代表NPS回访表单
      // let test = this.record.recordFormData.dedicateMode;
      return this.deepCopy(
        this.converTemp(
          this.record.recordFormData.dedicateMode.includes('404')
            ? SAafterSaleFormData
            : this.record.recordFormData.dedicateMode.includes('NPS')
            ? {
                name: this.bizData.contactsName,
                phone: this.bizData.contactsPhone
              }
            : SArecordFormData
        )
      );
    },
    doInit() {
      this.isShow = false;
      this.isHandle = false;
      this.record.openRecord = false;
      this.record.recordFormData = { exts: {} };
      this.record.SArecordFormData = { exts: {} };
      this.disableBtn = false; //恢复禁用的按钮
      this.osg.toast('保存成功！');
      this.getServiceAppointments();
      this.viewReload();
    },
    validate: function(formData, state) {
      formData = formData || 'formData';
      var pass = false;
      if (!this.$refs[formData]) return false;
      this.$refs[formData].$refs.formData.validate((valid, fileData) => {
        if (valid) pass = true;
        if (state == '0') {
          //创建线索，必填项忽略
          let ignoreObj = {
            area: true,
            phone: true,
            address: true,
            title: true,
            // channel: true,
            'exts.sourceType': true,
            'exts.leakagesite': true,
            sid: true, //选择工单
            afterSaleType: true, //类型细分
            relatedPerson: true //关联人
          };
          pass = true;
          for (let key in fileData) {
            //如果ignoreObj没有该字段则返回false
            if (!ignoreObj[key]) {
              console.log(ignoreObj, key, ignoreObj[key]);
              pass = false;
              this.$message({
                message: fileData[key][0].message,
                type: 'warning'
              });
              break;
            }
          }
        }
      });
      return pass;
    },
    //接受参数生成工单
    doSaveSA(params, callback) {
      if (!params) return;
      params.area = params.area || [];
      if (params.area.length > 0) {
        params.province = params.area[0] || '';
        if (params.area.length > 1) {
          params.city = params.area[1] || '';
          if (params.area.length > 2) {
            params.district = params.area[2] || '';
          }
        }
      }
      // 自定义字段转换值
      this.$util.saveFormatExtField(this.SAextFields, params);
      params.title = params.name + '的工单' + this.$util.readableTime();
      console.log(params);
      this.osg.ajax(
        'basic/serviceAppointment/upsert.do',
        { data: JSON.stringify(params) },
        res => {
          this.serviceAppointmentId = res.entity._id
          // this.osg.toast('操作成功！');
          if (callback) callback(res.entity);
        },
        { noload: true }
      );
    },
    //保存回访表单
    saveReview(formData, callback) {
      this.osg.getExtByColName('review', extId => {
        this.record.reviewFormData.state = 1; // 默认状态1
        let url = 'biz/extForm/upsert/' + extId + '.do';
        this.osg.ajax(url, { dataStr: JSON.stringify(formData) }, res => {
          if (callback) callback(res.entity);
        });
      });
    },
    //保存跟进记录ajax
    saveRecordAjax(data, callback) {
      //跟进记录需要前端生成_id
      data._id = data._id ? data._id : this.randomUUid();
      let params = {
        bizType: 'Lead',
        // bizId: this.id,
        callId: this.callId,
        callPhone: this.isIncomingCall
      };
      params = Object.assign(params, data);
      this.osg.ajax('followingUpNote/upsert.do', params, () => {
        if (callback) callback(params._id);
      });
    },
    //生成的客户特殊接口，返回客户对象，并把客户的id和线索的id都互相存储
    upsertLead(params, callback, state) {
      if (state == '0') {
        if (callback) callback({});
        return;
      }
      this.$util.saveExtField(this.SAextFields, params);
      if (params.gpsPoint) {
        params['gpsPoint.longitude'] = params.gpsPoint.longitude;
        params['gpsPoint.latitude'] = params.gpsPoint.latitude;
        delete params.gpsPoint;
      }
      this.osg.ajax(
        'basic/contacts/upsertLead.do',
        params,
        res => {
          if (callback) callback(res.entity);
        },
        {
          noload: true
        }
      );
    },
    // 保存售后工单
    saveWorkOrder(formData, callback) {
      this.osg.ajax('basic/workOrder/upsert.do', { data: JSON.stringify(formData) }, () => {
        if (callback) callback();
      });
    },
    //保存售后工单对象
    saveWorkflowAlert(exts, callback) {
      let extsData = this.$util.deepCopy(exts);
      //TODO:写死
      extsData.afterSaleType = JSON.stringify(extsData.afterSaleType);
      extsData.imagesAfterSale = JSON.stringify(extsData.imagesAfterSale);
      extsData.relatedPerson = Array.isArray(extsData.relatedPerson)
        ? extsData.relatedPerson.join(',')
        : '';
      //TODO:name和phone与工单的重了特殊处理
      extsData['nameAfterSaleSA'] = extsData.name;
      extsData['phoneAfterSaleSA'] = extsData.phone;
      delete extsData.name;
      delete extsData.phone;
      //将选择的关联人冗余存储中文
      let handleData = [];
      this.options['relatedPerson'].forEach(item => {
        if (this.record.SAafterSaleFormData.relatedPerson.indexOf(item._id) != -1) {
          handleData.push(item.name);
        }
      });
      if (handleData && handleData.length) extsData.handleUserNames = handleData.join('、');
      //拿到选中的工单对象
      let activeSA = this.options['sid'].filter(item => item._id == extsData.sid)[0];
      if (activeSA && activeSA.exts) {
        extsData.sTerritory = activeSA.exts.sTerritory; //工单片区
        extsData.orderNumSA = activeSA.orderNum; //工单编号
        extsData.leakagesite = JSON.stringify(activeSA.exts.leakagesite); //工单维修部位
        extsData.orgIdAfterSaleSA = activeSA.orgId; //工单服务商Id
        extsData.orgNameAfterSaleSA = activeSA.orgName; //工单服务商名称
        extsData.createTimeSA = activeSA.createTime; //工单创建时间
      }
      let params = {
        handlerIds: exts.relatedPerson,
        type: '1',
        type1Type: '1',
        memo: exts.describe,
        callIds: [this.callId],
        exts: extsData
      };
      params.orgId = activeSA.orgId; //工单服务商Id
      this.osg.ajax('biz/workflowAlert/addPostSalesService.do', params, res => {
        if (callback) callback();
      });
    },
    //400呼入，查询是否有来电
    // queryHasCall(params, callback) {
    //   params = params || {};
    //   this.osg.ajax(
    //     'basic/sobot/queryHasCall.do',
    //     params,
    //     res => {
    //       if (callback) callback(res);
    //     },
    //     { noload: true }
    //   );
    // },
    // 数组对象深复制
    deepCopy: function(data) {
      try {
        // 深拷贝
        let o = {
          run: function(val) {
            let result = '';
            if (val instanceof Array) {
              result = this.copyArr(val);
            } else {
              result = this.copyObj(val);
            }
            return result;
          },
          copyArr: function(arr) {
            var arr_temp = [];
            if (arr) {
              for (let i = 0, j = arr.length; i < j; i++) {
                if (arr[i] instanceof Array) {
                  arr_temp[i] = this.copyArr(arr[i]);
                } else if (arr[i] instanceof Object) {
                  arr_temp[i] = this.copyObj(arr[i]);
                } else arr_temp[i] = arr[i];
              }
            }
            return arr_temp;
          },
          copyObj: function(obj) {
            let obj_temp = {};
            for (let key in obj) {
              if (obj[key] instanceof Array) {
                obj_temp[key] = this.copyArr(obj[key]);
              } else if (obj[key] instanceof Object) {
                obj_temp[key] = this.copyObj(obj[key]);
              } else obj_temp[key] = obj[key];
            }
            return obj_temp;
          }
        };
        return o.run(data);
      } catch (error) {
        try {
          console.error(error);
          return JSON.parse(JSON.stringify(data));
        } catch (error) {
          console.error(error);
          return data;
        }
      }
    },
    doLeadSave(data, callback) {
      //   if (this.osg.validate()) {
      // 赋值省市区
      data.area = data.area || [];
      data.province = data.area[0] || '';
      data.city = data.area[1] || '';
      data.district = data.area[2] || '';
      this.saveExtField(this.SAextFields, data);
      //存经纬度用.的key来存值
      if (data.gpsPoint) {
        data['gpsPoint.longitude'] = data.gpsPoint.longitude;
        data['gpsPoint.latitude'] = data.gpsPoint.latitude;
        delete data.gpsPoint;
      }
      // lead/upsert接口exts内字段类型为数组时报500
      for (let key in data.exts) {
        if (Array.isArray(data.exts[key])) delete data.exts[key];
      }
      this.osg.ajax('basic/lead/upsert.do', data, res => {
        // this.doInit();
        // this.getWorkOrders();
        // this.osg.toast('保存成功！');
        // console.log(callback);
        if (callback) callback(res.data);
      });
      //   }
    },
    //保存NPS对象
    saveNPS(params, callback) {
      params.bizId = this.bizData._id;
      params.bizType = 'Contract';
      params.bizCode = this.bizData.contractdocNum;
      params.exts = params.exts || {};
      //NPS对象exts里冗余存储伙伴字段(id，省市区，服务商名称)
      if (this.bizData.partner) {
        params.partnerId = this.bizData.partner._id;
        params.partnerName = this.bizData.partner.name;
        params.partnerProvince = this.bizData.exts.province;

        params.exts.partnerProvince = this.bizData.exts.province;
        params.exts.partnerCity = this.bizData.exts.city;
        params.exts.partnerDistrict = this.bizData.exts.district;
      }
      //对NPS问题进行处理，将选择扣款的问题扣款
      // params.questionAndReply = params.questionAndReply.map(qItem => {
      //   if (qItem.whether > 0) {
      //     qItem.reply = String(qItem.question).slice(String(qItem.question).indexOf(',') + 1);
      //   } else {
      //     qItem.reply = '0';
      //   }
      //   return qItem;
      // });
      params.questionAndReply = params.questionAndReply.map(qItem => {
        if (!(qItem.whether > 0)) {
          qItem.reply = '0';
        }
        return qItem;
      });
      this.osg.ajax('basic/nps/upsert.do', params, () => {
        if (callback) callback();
      });
    },
    //选择罚款问题change事件
    selectionQuestion(opValue, row) {
      for (let item of this.options['questionBank']) {
        if (item._id == opValue) {
          row.reply = item.price || 0;
        }
      }
      // row.reply =
      //   this.findParameterKey(
      //     this.options['questionBank'].find(item => item._id == opValue),
      //     'reply'
      //   ) || '0';
    },
    //查找参数表里的key
    findParameterKey(row, key) {
      let replyData = row.parameterList.find(paramItem => paramItem.key == key);
      return replyData && replyData.value;
    },
    //给字典表扩展属性
    getParameterData(sourceTypeType, callBack) {
      if (!sourceTypeType) return;
      this.osg.ajax(
        'code/query.do',
        {
          type: sourceTypeType,
          'nin:state|integer#and': [-1],
          _all: '1'
        },
        codeRes => {
          let params = {
            _all: '1',
            'in:state|array-integer#and': '0,1',
            'in:sourceType|integer#and': 2, //参数来源
            'is:sourceTypeType|string#and': sourceTypeType,
            sortField: 'key',
            sortOrder: 'desc'
          };
          this.osg.ajax('parameter/query.do', params, res => {
            this.options[sourceTypeType] = codeRes.data.map(item => {
              item.parameterList = [];
              res.data.forEach(pItem => {
                if (item._id == pItem.sourceTypeId) item.parameterList.push(pItem);
              });
              item.label = item.name;
              return item;
            });
            if (callBack) callBack();
          });
        }
      );
    },
    getForfeitRules(type, sourceTypeType, callBack) {
      if (!sourceTypeType) return;
      this.osg.ajax(
        'basic/forfeitRule/query.do',
        {
          _all: '1',
          'is:state|integer#and': 1,
          'is:type|integer#and': type
        },
        res => {
          this.options[sourceTypeType] = res.data;
          if (callBack) callBack();
        }
      );
    },
    //生成线索对象的数据模板
    converTemp(row, assignData) {
      console.log(row);
      row.exts = row.exts || {};
      let obj = {
        // contactIds: [row._id],
        name: row.name,
        address: row.address,
        area: row.area,
        // belongTo: row.belongTo,
        province: row.province,
        city: row.city,
        district: row.district,
        phone: row.phone,
        channel: row.channel,
        customTime: row.retentionDate || row.exts.retentionDate || this.$util.readableTime(), //TODO:写死的，座机是写死的html
        exts: row.exts
        // leadIds: [row._id]
      };
      //TODO:写死的，线索删除工单的扩展字段
      //   delete obj.exts.retentionDate;
      //TODO:写死的，工单预设字段给线索的扩展字段赋值
      obj.exts.memo = row.describe;
      obj.exts.leadDiscrepancy = obj.exts.leadDiscrepancy || row.leadDiscrepancy;
      //防止报错
      delete obj.exts.type;
      delete obj.exts.typeDetail;
      // 防止字段未{}，会返显为undefined
      // if (obj.exts.retentionDate.constructor == Object) obj.exts.retentionDate = '';
      return Object.assign(obj, assignData ? assignData : {});
    },
    // 解决自定义字段不能传数组
    saveExtField(extFields, row) {
      for (let field of extFields) {
        if (field.preset == '1') continue;
        if (field.type == 'checkbox' || field.type == 'cascade') {
          row.exts[field.name] = JSON.stringify(row.exts[field.name]);
        } else if (field.type == 'file') {
          if (Array.isArray(row.exts[field.name])) {
            row.exts[field.name] = row.exts[field.name].map(item => {
              return {
                url: this.osg.downloadUrl + item.response.key.replace(this.osg.downloadUrl, ''),
                name: item.response.key
              };
            });
          } else {
            row.exts[field.name] = [];
          }
        }
      }
      return row;
    },
    //生成uuid（18位），随机数（5位）+时间戳（13位）
    randomUUid() {
      let num = '';
      for (var i = 0; i < 5; i++) {
        num += Math.floor(Math.random() * 10);
      }
      return num + new Date().valueOf();
    },
    async codeoption(callback) {
      var opts = this.options;
      if (opts) {
        var cfgArr = [];
        var cascadeTypes = []; //级联的代码类型
        for (var o in opts) {
          if (o.startsWith('codecfg_')) {
            var cfg = opts[o];
            cfg['eleid'] = o.substring(8);
            cfgArr.push(cfg);
          }
          //组合级联代码类型
          if (o.startsWith('cascadeCode_')) {
            let type = o.substring(12);
            cascadeTypes.push(type);
          }
        }
        await new Promise(resolve => {
          if (cfgArr.length > 0) {
            let params = JSON.stringify(cfgArr);
            this.osg.ajax(
              'i/code/selectCode.do',
              {
                jsonPara: params
              },
              res => {
                if (res) {
                  res = JSON.parse(res);
                  for (var i = 0; i < res.length; i++) {
                    var opts = res[i],
                      os = opts.options;
                    var osArr = [];
                    for (var opt in os) {
                      osArr.push({
                        label: os[opt],
                        value: opt
                      });
                    }
                    this.options[opts.eleid] = osArr;
                  }
                  resolve();
                  // if (callback) callback();
                }
              },
              {
                noload: true
              }
            );
          } else {
            resolve();
          }
        });
        await new Promise(resolve => {
          //查询级联代码表数据
          if (cascadeTypes.length > 0) {
            this.osg.ajax(
              'i/code/selectMultistageCode.do',
              {
                types: cascadeTypes.join(),
                tenantId: JSON.parse(sessionStorage['entity']).tenantId
              },
              res => {
                if (res.constructor == Array) {
                  res.map(item => {
                    this.options[item.type] = this.removeEmpty(item.children, 'children');
                  });
                }
                resolve();
              },
              {
                noload: true
              }
            );
          } else {
            resolve();
          }
        });
        if (callback) callback();
      }
    },
    //根据工单客户姓名自动生成工单标题
    changeName(val) {
      this.$set(this.record.SArecordFormData, 'title', val + '的工单' + this.$util.readableTime());
    },
    //根据输入的手机号请求工单
    SAafterSalePhone() {
      //   console.log(this.record.SAafterSaleFormData.phone);
      if (this.record.SAafterSaleFormData.phone) {
        this.osg.ajax(
          'basic/serviceAppointment/query.do',
          {
            'regex:phone|string#and': this.record.SAafterSaleFormData.phone,
            // 'all:exts.contactsPhone|array#or': this.record.SAafterSaleFormData.phone,
            rows: 100
          },
          res => {
            this.$set(this.options, 'sid', res.data);
            console.log(this.options);
          },
          {
            // headers: {'X-Auth-Token':this.token },
            noload: true
          }
        );
      } else {
        this.$set(this.options, 'sid', []);
      }
    },
    //切换工单
    sidChange() {
      if (this.record.SAafterSaleFormData.sid) {
        this.osg.ajax(
          'biz/workflowAlert/queryAboutHandleUsers.do',
          {
            sid: this.record.SAafterSaleFormData.sid,
            code: this.record.recordFormData.dedicateMode[
              this.record.recordFormData.dedicateMode.length - 1
            ]
          },
          res => {
            this.$set(this.options, 'relatedPerson', res.data);
            this.record.SAafterSaleFormData.relatedPerson = '';
          },
          {
            fail: () => {
              this.$set(this.options, 'relatedPerson', []);
              this.record.SAafterSaleFormData.relatedPerson = '';
            }
          }
        );
      } else {
        this.$set(this.options, 'relatedPerson', []);
        this.record.SAafterSaleFormData.relatedPerson = '';
      }
      this.$forceUpdate();
    },
    // 删除空数组
    removeEmpty(arr, children) {
      let childrenName = children || 'children';
      if (Array.isArray(arr)) {
        arr.forEach(item => {
          if (item[childrenName] ? item[childrenName].length === 0 : false) {
            delete item[childrenName];
          } else {
            this.removeEmpty(item[childrenName]);
          }
        });
        return arr;
      }
    },
    // 获取历史服务工单
    getServiceAppointments(phone) {
      this.osg.ajax(
        'basic/serviceAppointment/query.do',
        {
          // _all: 1,
          page: 1,
          rows: 50,
          'is:state|integer#and': 1,
          'is:phone|string#and': phone || this.searchValue,
          // 'all:exts.contactsPhone|array#or': phone || this.searchValue,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.serviceAppointmentFpi = res;
        },
        {
          // headers: {'X-Auth-Token':this.token },
          noload: true
        }
      );
    },
    //获取历史售后工单
    getWorkOrders(phone) {
      var params = {
        // _all: 1,
        page: 1,
        rows: 50,
        'is:state|integer#and': 1,
        'is:phone|string#and': phone || this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax(
        'basic/workOrder/query.do',
        params,
        res => {
          this.fpi = res;
        },
        { noload: true }
      );
    },
    getLeads(phone) {
      this.osg.ajax(
        'basic/lead/query.do',
        {
          _all: 1,
          // page:  1,
          // rows: 50,
          'is:state|integer#and': 1,
          'is:phone|string#and': phone || this.searchValue,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.leadFpi = res;
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        },
        {
          // header: {'X-Auth-Token':this.token },
          noload: true
        }
      );
    },
    getContact() {
      if (!this.isIncomingCall) return;
      this.osg.ajax(
        'basic/contacts/query.do',
        {
          page: 1,
          rows: 1,
          'is:state|integer#and': 1,
          'is:phone|string#and': this.isIncomingCall
        },
        res => {
          this.contact.formData = res.data[0] || { exts: {} };
          this.$nextTick(() => {
            this.$forceUpdate();
          });
        },
        { noload: true }
      );
    },
    // 通话状态发生改变
    dedicateModeChange() {
      this.record.recordFormData.afterSaleType = '';
      if (
        this.record.recordFormData.dedicateMode &&
        this.record.recordFormData.dedicateMode.includes('404')
      ) {
        // this.SAafterSalePhone(); //mounted后请求售后工单
      } else if (
        this.record.recordFormData.dedicateMode &&
        this.record.recordFormData.dedicateMode.includes('NPS')
      ) {
        this.getExtFieldsNPS(() => {
          this.getExtFieldsContract(() => {
            this.osg.codeoption(() => {
              this.codeoption(() => {
                window.$this.options = Object.assign(window.$this.options, this.options);
                console.log(this.options, window.$this.options);
                this.contractShow = false;
                this.searchContractValue = this.isIncomingCall; //手机号赋值到过滤合同列表文本框中
                this.getContract();
              });
            });
          });
        });
      }
    },
    /**
     * NPS 合同
     */
    //获取NPS表单
    getExtFieldsNPS(callback) {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'netPromoterScore',
          _all: '1',
          'is:state|integer#and': 1,
          //   'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.extFieldsNPS = res.data;
          this.options = this.options || [];
          for (var item of res.data) {
            //解析字段配置
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
          }
          if (callback) callback();
        },
        { noload: true }
      );
    },
    //获取合同对象
    getExtFieldsContract(callback) {
      this.osg.ajax(
        'biz/extField/query.do',
        {
          colName: 'contract',
          _all: '1',
          'is:state|integer#and': 1,
          //   'nin:preset|array-integer#and': 1,
          sortField: 'order',
          sortOrder: 'asc'
        },
        res => {
          this.extFieldsContract = res.data;
          this.options = this.options || [];
          window.$this.options = window.$this.options || [];

          for (var item of res.data) {
            //解析字段配置
            if (this.$util.isJson(item.frontEndConfig)) {
              item.frontEndConfig = JSON.parse(item.frontEndConfig);
            } else {
              item.frontEndConfig = {};
            }
            if (item.valueOption) {
              this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
              window.$this.options['codecfg_' + item.valueOption] = {
                codeId: item.valueOption
              };
            }
            //级联
            if (item.type == 'cascade')
              this.options['cascadeCode_' + item.valueOption] = {
                codeId: item.valueOption
              };
            window.$this.options['cascadeCode_' + item.valueOption] = {
              codeId: item.valueOption
            };
          }
          if (callback) callback();
        },
        { noload: true }
      );
    },
    //初始化NPS表单
    initNpsForm(data) {
      let that = this;
      //如果关联合同第二次拨号 则反显
      this.getNPS({ bizId: data.bizId, bizType: data.bizType }, NPSdata => {
        // this.getParameterData('questionBank', () => {
        this.getForfeitRules(1, 'questionBank', () => {
          if (NPSdata) {
            //给选项设置默认值
            NPSdata.questionAndReply = NPSdata.questionAndReply.map(item => {
              if (!item.whether) item.whether = '0';
              return item;
            });
            that.record.NPSformData = NPSdata || {};
            //   that.options['questionBank_random'] = that.options['questionBank'];
            if (that.record.NPSformData.mode) delete that.record.NPSformData.mode; //清空回访状态
          } else {
            this.record.NPSformData = { questionAndReply: [] };
            //   that.options['questionBank_random'] = [];
            let questionBankCopy = that.$util.deepCopy(that.options['questionBank']);
            //随机给出nps问题
            for (let i = that.randomQuestionNum; i > 0; i--) {
              let randomNum = Math.floor(Math.random() * questionBankCopy.length);
              // that.options['questionBank_random'].push(questionBankCopy[randomNum]);
              that.record.NPSformData.questionAndReply.push({
                id: questionBankCopy[randomNum]._id,
                question: questionBankCopy[randomNum].name,
                reply: questionBankCopy[randomNum].price || '0',
                whether: ''
              });
              questionBankCopy.splice(randomNum, 1);
            }
            console.log(that.record.NPSformData.questionAndReply);
          }
        });
      });
    },
    //NPS表单
    validateCForm() {
      var pass = false;
      this.$refs['NPSform'].$refs['formData'].validate(valid => {
        if (valid) pass = true;
      });
      return pass;
    },
    //合同列表选择行
    selectionChange(rows) {
      this.selectedList = rows;
    },
    //合同列表勾选当前行
    currentSelection(rows) {
      if (rows.length > 1) this.$refs.contractTable.toggleRowSelection(rows.shift(), false); //单选
      //只有没选中合同才会跳到下一步
      if (rows[0] || rows[0]._id) {
        this.initNpsForm({ bizId: rows[0]._id, bizType: 'Contract' });
        this.bizData = rows[0];
        this.stepsActive = 1;
      }
    },
    //获取合同列表
    getContract() {
      var params = {
        page: this.contractFpi.page,
        rows: this.contractFpi.rows,
        'exists:endDate|boolean#and': true, //已完工的合同
        'in:state|array-integer#and': '1', //合同状态
        'regex:contactsName|string#or': this.searchContractValue,
        'regex:contactsPhone|string#or': this.searchContractValue,
        'regex:contractdocNum|string#or': this.searchContractValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('basic/contract/query.do', params, res => {
        this.contractFpi = res;
        this.$nextTick(() => {
          console.log(window.$this.options);
          this.contractShow = true;
          this.$nextTick(() => {
            this.$refs.contractTable.doLayout();
            this.$forceUpdate();
          });
        });
      });
    },
    //步骤条上一步，选择合同
    stepLast() {
      this.stepsActive = 0;
    },
    //获取NPS列表
    getNPS(params, callback) {
      this.osg.ajax(
        'basic/nps/query.do',
        params,
        res => {
          if (res.data) {
            if (callback) callback(res.data[0]);
          }
        },
        {
          noload: true
        }
      );
    },
    changeForm(data) {
      this.record.SArecordFormData = window.$this.$util.deepCopy(
        Object.assign(this.record.SArecordFormData, data)
      );
    },
    pageSizeChange(pageSize, fpiName, fn) {
      fpiName = fpiName || 'fpi';
      console.log(this[fpiName]);
      this[fpiName].rows = pageSize;
      if (fpiName == 'fpi') {
        this.getWorkOrders();
      } else {
        fn();
      }
    },
    pageChange(currentPage, fpiName, fn) {
      fpiName = fpiName || 'fpi';
      console.log(this[fpiName]);
      this[fpiName].page = currentPage;
      if (fpiName == 'fpi') {
        this.getWorkOrders();
      } else {
        fn();
      }
    },
    formatWorkOrderType(cellValue) {
      if (!cellValue) return '';
      return this.osg.codelabel('workOrderType', cellValue, this);
    },
    uploadSuccess(response, file, fileList) {
      console.log(fileList);
      return fileList;
    },
    beforeUpload() {
      return this.osg.beforeUpload(...arguments, this);
    },
    beforeRemove() {
      return this.osg.beforeRemove(...arguments, () => {}, this);
    },
    /**
     *
     *
     */

    // 暂时未用到
    // 查询是否有客服的呼入呼出权限
    // callAuthority() {
    //   let that = this;
    //   if (this.serviceState) {
    //     clearInterval(timer);
    //     const timer = setInterval(() => {
    //       //如果呼入表单被打开了，则不轮询调用查看是否来电
    //       if (that && that.$refs && that.$refs.callOutStrip) {
    //         if (that.$refs.callOutStrip.isHandle) {
    //           return;
    //         }
    //       }
    //       // 400呼入，查询是否有来电
    //       this.queryHasCall({}, res => {
    //         //当返回值有data，说明来电
    //         if (res.data) {
    //           this.callId = res.data.callId;
    //           this.isIncomingCall = res.data.phone;
    //           if (res.data.level) this.callOutStripTheme.themeColor = res.data.level;
    //         } else {
    //           this.callId = '';
    //           this.isIncomingCall = '';
    //           this.callOutStripTheme.themeColor = '';
    //         }
    //       });
    //     }, 3000);

    //     // 通过$once来监听定时器，在beforeDestroy钩子可以被清除。
    //     this.$once('hook:beforeDestroy', () => {
    //       clearInterval(timer);
    //     });
    //   }
    // },
    //同一浏览器新建标签页，如果有token不需要重新登录
    getAccount() {
      return new Promise(resolve => {
        this.osg.ajax(
          '/account/getOneself.do',
          {},
          res => {
            sessionStorage['entity'] = JSON.stringify(res);
            // this.osg.customize.bizId = res.entityID;
            // this.osg.customize.entity = res;
            // this.isIncomingCall = res.accountName;
            resolve();
          },
          {
            // header: {'X-Auth-Token':this.token },
            noload: true
          }
        );
      });
    },
    // 单点登录，获取token
    getToken(callback) {
      var params = {
        appKeyCode: this.routerData
      };
      // return new Promise(resolve => {
      this.osg.ajax(
        'i/sso/appKeyCode.do',
        params,
        res => {
          // let token = res['X-Auth-Token'];
          if (res.success == 'true') {
            // this.$util.cookie.set(
            //   this.$util.cookieRelative.token,
            //   token,
            //   this.$util.cookieRelative.tokenExpires
            // );
            sessionStorage['token'] = JSON.stringify(res['X-Auth-Token']);
          } else {
            this.$router.push('/');
            this.$util.cookie.deleteCookie('X-Auth-Token');
            this.$util.cookie.deleteCookie('SERVERID');
            sessionStorage.clear();
          }
          // this.osg.customize.bizId = res.entityID;
          // this.osg.customize.entity = res;
          // resolve();

          if (callback) callback();
        },
        { method: 'GET' },
        {
          noload: true
        }
      );
      // });
    },
    // crm工单状态返回给udesk
    crmState() {
      var params = {
        phone: this.isIncomingCall,
        crmStatus: '已建单'
      };
      this.osg.ajax('biz/ud/updateCustomerToUdesk.do', params, res => {});
    },
    // 更新保存通话记录
     updateCallLog() {
        var params = {
          call_id: this.call_id,
          serviceAppointmentId:this.serviceAppointmentId
        };
        this.osg.ajax(
          'biz/ud/updateCallLog.do',
          params,
          res => {
            console.log(res,'---------大表单更新保存通话记录res')
            // this.record = res.data.entity;
          },
          // { noload: true }
        );
    },    
    // 获取省市区字典表数据
    getConfig() {
      this.osg.ajax(
        '/config/query.do',
        {},
        res => {
          if (res.cascadeArea) {
            this.osg.ajax('~' + this.osg.downloadUrl + res.cascadeArea, {}, res => {
              if (this.osg.areaList.length == 0) {
                res.areaList.map(item => {
                  this.osg.areaList.push(item);
                });
                window.$this.areaShow = false;
                window.$this.$nextTick(() => {
                  window.$this.areaShow = true;
                });
              }
            });
          }
          if (res.areaListWithStreet) {
            this.osg.ajax('~' + this.osg.downloadUrl + res.areaListWithStreet, {}, res => {
              this.osg.areaObj = res;
              window.$this.areaShow = false;
              window.$this.$nextTick(() => {
                window.$this.areaShow = true;
              });
            });
          }
        }
        // {
        //   header: {'X-Auth-Token':this.token },
        // }
      );
    }
  },
  watch: {
    'record.SArecordFormData.area'() {
      if (this.$refs.areaSelectorRSA) {
        this.$refs.areaSelectorRSA.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    'record.SArecordFormData'() {
      if (!this.record.SArecordFormData.gpsPoint) {
        this.record.SArecordFormData.gpsPoint = {};
      }
      if (!this.record.SArecordFormData.exts) {
        this.record.SArecordFormData.exts = {};
      }
    },
    //综合跟进表单，信息渠道
    'record.SArecordFormData.channel'() {
      if (this.$refs.cascaderRRchannel) {
        this.$refs.cascaderRRchannel.dropDownVisible = false; //监听值发生变化就关闭它
      }
    },
    //综合跟进表单，通话状态
    'record.recordFormData.dedicateMode'() {
      if (this.$refs.cascaderRRdedicateMode) {
        this.$refs.cascaderRRdedicateMode.dropDownVisible = false; //监听值发生变化就关闭它
      }
      this.refresh = false;
      this.$nextTick(() => {
        this.refresh = true;
        this.$forceUpdate();
      });
    }
  },
  computed: {
    timingStr() {
      return `${this.timingHour}:${this.$util.fillZero(this.timingMinute)}:${this.$util.fillZero(
        this.timingSecond
      )}`;
    }
  }
};
</script>
<style lang="scss">
// #phoneStrip-wrapper {
//   width: 100%;
//   height: 70px;
//   background: #409eff;
//   position: sticky;
//   z-index: 4000;
//   top: 0px;
//   right: 0;
//   margin-bottom: 4px;
//   border-radius: 0 0 5px 5px;
// }
// #phoneStrip-wrapper .el-menu-item {
//   background-color: transparent !important;
// }
// #phoneStrip-wrapper ul li {
//   height: 100%;
//   line-height: 70px;
// }
// #phoneStrip-wrapper .is-active {
//   background: #60626675 !important;
//   border-bottom: 2px solid #60626675 !important;
//   color: #fff;
// }
// #phoneStrip-wrapper .menu-wrapper {
//   background: #409eff;
//   width: 100%;
//   height: 70px;
//   display: flex;
//   justify-content: flex-end;
//   flex: 1;
//   border-bottom: none;
//   border-radius: 4px;
// }
#phoneStrippopUp-wrapper {
  width: 116px;
  height: 70px;
  /* background: red; */
  position: sticky;
  z-index: 99999;
  top: 0px;
  right: 0;
  margin-bottom: 4px;
  border-radius: 4px;
}
#phoneStrippopUp-wrapper .userSelect-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  width: 100%;
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
}

#comprehensiveDialog .el-dialog {
  width: 70vw;
  min-width: 1000px;
  // margin: 68px auto !important;
  border-radius: 0 0 5px 5px;
  display: flex;
  flex-direction: column;
  // height: calc(100% - 140px);
  margin: 0 !important;
}

#comprehensiveDialog .el-dialog__body {
  overflow-y: auto;
  flex: 1;
  padding: 20px 50px;
}
#comprehensiveDialog .el-dialog__footer {
  padding: 10px 15px;
  border-top: 1px solid #e8eaec;
  box-sizing: border-box;
}
#comprehensiveDialog .el-form-item__content > div {
  width: 100% !important;
}
#listDialog .el-dialog__body {
  height: 60vh;
}
#listDialog .el-dialog {
  width: 600px;
  min-width: 400px;
  max-width: 95%;
  // margin: 10vh auto 10vh !important;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
}

.el-form--inline {
  display: flex;
  flex-wrap: wrap;
}
.el-form--inline .el-input__inner {
  width: 100%;
}
.el-form--inline .el-textarea__inner {
  width: 100%;
}
.el-form--inline .el-form-item {
  width: 24%;
  margin-right: 1%;
  margin-bottom: 10px;
  .el-form-item__label {
    padding-bottom: 0 !important;
  }
  .el-input__suffix {
    right: 0;
  }
}

.el-form--inline .el-input__suffix {
  right: 40px;
}
#comprehensiveDialog .el-dialog__header {
  display: none;
}
.phoneStrip-dialog .phone-card {
  .el-card__body {
    .el-form-item {
      width: 100%;
    }
  }
}
</style>
